import { defaultDataIdFromObject } from '@apollo/client';
import type { StoreObject } from '@apollo/client/cache';

/**
 * Defines custom ID matcher, by which entities are cached and matched in cache
 * Together with cacheRedirects (see bellow) this optimizes fetching
 * by sharing already fetched data between queries
 *
 * @param {any} object
 * @return {string} id
 */
export const dataIdFromObject = (object: Readonly<StoreObject>): string | undefined => {
  /**
   * If __typename match is not found object.id is used as default
   */
  // eslint-disable-next-line no-underscore-dangle
  switch (object.__typename) {
    case 'PasswordAuthUser':
      return object.invitation ? `${object.id}-${(object.invitation as StoreObject).id}` : (object.id as string);

    case 'PermissionScope':
      return `permission-scope-${object.context}-${object.entityId}`;

    default:
      return defaultDataIdFromObject(object);
  }
};
